import { Grid } from "@mui/material"
import React, { useContext, useEffect, useMemo, useRef, useState } from "react"
import { useNavigate } from "react-router"
import { TableauDashboard } from "../../components/TableauDashboard/TableauDashboard"
import { pagesUrl } from "../../core/appConstants"
import { OrganizationContext } from "../../core/context/organization/organization-context"
import { useOrganization } from "../../core/hooks/use-organization"
import { resolveUrl } from "../../core/services/http-service"
import { TableauViz } from "../../core/services/tableau/tableau-service"
import { IconInbox } from "../../components/custom-icons/icon-inbox"
import { customPalette } from "../../../theme"
import { AppSideBarContext } from "../../core/context/AppSideBarContext/AppSideBarContext"
import { AppNavBarContext } from "../../core/context/nav-bar/AppNavBarContext"

export function GlobalRseeDashboardPage(): React.JSX.Element {
  const navigate = useNavigate()
  const { fetchOrganizationDashboardUrl } = useOrganization()

  const { setShowAppSide, setFullScreen } = useContext(AppSideBarContext)
  const { setTitle, setPreviousUrl, setIcon, setBreadcrumbSteps } = useContext(AppNavBarContext)
  const { organization } = useContext(OrganizationContext)

  const [dashboardUrl, setDashboardUrl] = useState<string | undefined>(undefined)
  const filterToAdd = useMemo(() => [], [])

  useEffect(() => {
    setShowAppSide(true)
    setTitle("Tableau de bord global RSEE")
    setPreviousUrl(pagesUrl.HOME)
    setBreadcrumbSteps([])
    setIcon(<IconInbox sx={{ color: customPalette.black, fontWeight: "2px" }} />)
  }, [setShowAppSide, setTitle, setPreviousUrl, setIcon, setFullScreen, setBreadcrumbSteps])

  const viz: React.MutableRefObject<any> = useRef<any>(new TableauViz())

  useEffect(() => {
    fetchOrganizationDashboardUrl()
      .then((url) => {
        setDashboardUrl(url)
      })
      .catch(() => {
        navigate(resolveUrl(pagesUrl.HOME, [], {}))
      })
  }, [fetchOrganizationDashboardUrl, navigate])

  return (
    <Grid container>
      <Grid item xs={12}>
        {dashboardUrl && organization?.id && (
          <TableauDashboard
            dashboardUrl={dashboardUrl}
            isDataReady
            tableauParameter={[{ name: "0P_Organization_Id", value: [organization.id] }]}
            filterToAdd={filterToAdd}
            vizRef={viz}
          />
        )}
      </Grid>
    </Grid>
  )
}
